export default __webpack_public_path__ + "static/media/chat-blue.6b4e2213.svg";